export const emissionItemCategories = {
	all: 'All',
	popular: 'Popular',
	others: 'Others',
	addYourOwn: 'Add your own',
	businessTravel: 'Business Travel',
	transport: 'Transport',
	energyConsumption: 'Energy Consumption',
	consumerGoodsAndServices: 'Consumer Goods & Services',
	informationAndCommunication: 'Information & Communication',
	financeAndInsuranceServices: 'Finance & Insurance Services',
	waste: 'Waste',
	agricultureAquacultureAndForestry: 'Agriculture, Aquaculture and Forestry',
	realEstate: 'Real Estate',
	leasedAssetsRental: 'Leased Assets / Rental',
	foodAndBeverage: 'Food and Beverage',
}
